import React from "react";
import makeStyles from "@mui/styles/makeStyles";
import { Button } from "@mui/material";
import { KeyValue, Query } from "../interfaces";

const useStyles = makeStyles(theme => ({
  editColumnCustomizedComparison: {
    height: 40,
    marginTop: 4,
    marginBottom: 0,
    width: 160,
    fontSize: 16,
  },
  editColumnStandardComparison: {
    "&.MuiButton-containedSecondary": {
      height: 40,
      marginTop: 8,
      marginBottom: 4,
      marginLeft: 8,
    },
  },
}));

interface Props {
  appState: Query;
  updateUi: (
    filter: string,
    value: string | string[] | KeyValue[] | undefined,
  ) => void;
  updateFilters: (filter: string, value: string[]) => void;
  customComparison?: boolean;
}
function EditColumn({
  updateUi,
  updateFilters,
  customComparison,
  appState,
}: Props) {
  const classes = useStyles();
  const step = appState.ui.comparisonType !== "" ? "step1" : "step2";
  return (
    <Button
      id="edit-column"
      className={
        customComparison
          ? classes.editColumnCustomizedComparison
          : classes.editColumnStandardComparison
      }
      variant="contained"
      color="secondary"
      onClick={() => {
        updateUi("pgcStep", step);
        updateUi("incomeBasis", ["YTD"]);
        updateUi("unitType", ["$"]);
        updateUi("reportType", undefined);
        updateUi("reportStructure", undefined);
        updateFilters("reportPeriod", [""]);
      }}
    >
      Edit Columns
    </Button>
  );
}
export default EditColumn;
